import { useContext } from "react";

import { ClickTrackerService } from "@app/util/clickTracker/ClickTrackerService";

import ClickTrackerContext from "./ClickTrackerContext";

const useClickTrackerContext = (): ClickTrackerService =>
  useContext<ClickTrackerService>(ClickTrackerContext);

export default useClickTrackerContext;
